import { CONTEXT_PROPS } from '../../../types/ContextProps';
import { get, getRawValue } from '../../../utils/get';
import { sanitizeUrl } from '../../../utils/sanitize-url';
import { QUERY_DEFAULT_ALLOWLIST } from '../../../consts/consts';
import { experimentEnabled } from '../../../adapters/experimentEnabled';
var removeTrailingSlash = function (url) { return url.replace(/\/+$/, ''); };
export var getPageUrl = function (item) {
    if (item === void 0) { item = {}; }
    var siteUrl = get(item, "context.".concat(CONTEXT_PROPS.SITE_URL));
    var defaultUrl = get(item, "context.".concat(CONTEXT_PROPS.DEFAULT_URL));
    var isHomePage = getRawValue(item, "context.".concat(CONTEXT_PROPS.IS_HOME_PAGE));
    var urlWithoutQuery = defaultUrl.split('?')[0];
    var isCurrentHomePage = removeTrailingSlash(urlWithoutQuery) === removeTrailingSlash(siteUrl);
    var url = isHomePage && !isCurrentHomePage ? siteUrl : defaultUrl;
    var context = getRawValue(item, 'context');
    var siteLanguages = getRawValue(context, CONTEXT_PROPS.SITE_LANGUAGES);
    var allowedLangValues = [].concat(siteLanguages === null || siteLanguages === void 0 ? void 0 : siteLanguages.map(function (lang) { return lang.languageCode; }), siteLanguages === null || siteLanguages === void 0 ? void 0 : siteLanguages.map(function (lang) { return lang.locale; }));
    var enableLangCheck = experimentEnabled('specs.seo.enableLangCheck', context);
    return sanitizeUrl(url, QUERY_DEFAULT_ALLOWLIST, enableLangCheck ? allowedLangValues : undefined);
};
